import { ApolloLink } from '@apollo/client'

import { GetServerDateQueryDocument } from '../GetServerDate.query.generated'

/**
 * @private only to be used in apolloClient.ts
 */
export const dateServerLink = new ApolloLink((operation, forward) => {
  const { cache } = operation.getContext()

  return forward(operation).map((data) => {
    const context = operation.getContext()
    const requestDate = context.response.headers.get('Date')
    const serverTime = new Date(requestDate).getTime() + context.timeRequest

    cache.writeQuery({ query: GetServerDateQueryDocument, data: { server: new Date(serverTime) } })

    return data
  })
})
